<template>
  <div id="mainPage">
    <div id="main">
      <div class="messageBox">
        system: {{message}}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
  },
  data () {
    return {
      message: ''
    }
  },
  methods: {
  },
  computed: {
    ...mapGetters([
      'winners',
      'winnersById',
      'winnersIndexById',
      'winnersByAwardType',
      'winningWorkById'
    ])
  },
  created () {
  },
  mounted () {
    if (this.$route.params.type == 'clear') {
      localStorage.removeItem("openMode");
      localStorage.removeItem("closeMode");
      this.message = 'clear';
    } else if (this.$route.params.type == 'open') {
      localStorage.setItem('openMode', 'true');
      this.message = 'mode open';
    } else if (this.$route.params.type == 'close') {
      localStorage.setItem('closeMode', 'true');
      this.message = 'mode close';
    } else if (this.$route.params.type == 'status') {
      const openMode = localStorage.getItem('openMode');
      const closeMode = localStorage.getItem('closeMode');
      this.message = `openMode=${openMode} closeMode=${closeMode}`
    }
  },
  watch: {
  }
}
</script>

<style scoped>
#main {
  display: flex;
  justify-content: row;
  align-items: center;
  flex-direction: column;
}

.messageBox {
  max-width: 500px;
  height: 600px;
  padding-top: 200px;
  text-align: center;
  font-size: 1rem;
  background-color: white;
}
</style>
